import { FriendlyNameNotRequiredProducts } from './types';

const FRIENDLY_NAME_NOT_REQUIRED_PRODUCTS: FriendlyNameNotRequiredProducts[] = [{
  productId: '401',
  value: 'captureclient',
}, {
  productId: '409',
  value: 'cloudsecureedge',
}];

export {
  FRIENDLY_NAME_NOT_REQUIRED_PRODUCTS,
};
